import React from 'react';
import styles from './style.module.css';
import StepFiveForm from '../../components/forms/step-five';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Loan Intro Title</p>
        <h1 className={styles.mainTitle}>Term of Loan</h1>
        <p className={styles.text}>Content relating to the term of loan.</p>
        <StepFiveForm/>
    </div>
);
